document.addEventListener('turbolinks:load', function() {
  var anticipationCheckbox = document.getElementById('anticipation');
  var justifyInput = document.getElementById('justify');
  var fileInput = document.getElementById('file');

  if (anticipationCheckbox && justifyInput && fileInput) {
    anticipationCheckbox.addEventListener('change', toggleValidation);
    toggleValidation();
  }
});

function toggleValidation() {
  var anticipationCheckbox = document.getElementById('anticipation');
  var justifyInput = document.getElementById('justify');
  var fileInput = document.getElementById('file');
  var cacheFileInput = document.getElementById('file_cache');
  var divFile = document.getElementById('divFile');

  if (anticipationCheckbox.checked) {
    justifyInput.required = true;
    divFile.style.display = 'block';
    if (cacheFileInput== null){
      fileInput.required = true;
    }
  } else {
    justifyInput.required = false;
    divFile.style.display = 'none';
    fileInput.required = false;
  }
}
